// extracted by mini-css-extract-plugin
module.exports = {"links":"BlogSocialLinks_links__pDOTM","label":"BlogSocialLinks_label__IxTid"};